// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4bb39b01","422":"8017f441","558":"a62c4cb3","574":"c74e0856","654":"c5c701fc","671":"ff9b275a","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};